import authProvider from './src/authProvider';
import dataProvider from './src/dataProvider';

export {
  authProvider,
  dataProvider,
}